import { getButtonClassnames } from '@shared/universal/utils/buttonUtils'
import React from 'react'

import {
  selectAvailableCurrencies,
  selectCurrentDomain,
  selectCurrency,
  selectUrls,
} from '../../stores/selectors'
import { generateUrl } from '../../utils/url'

export const SiteSettings = () => {
  const currentDomain = selectCurrentDomain()
  const urls = selectUrls()
  const availableCurrencies = selectAvailableCurrencies()
  const currency = selectCurrency()

  const handleCurrencyChange = (code: string) => (ev: React.MouseEvent) => {
    ev.preventDefault()
    window.location.href = generateUrl(window.location.href, code)
  }

  return (
    <nav className='flex absolute right-4'>
      <div className='settings-dropdown relative'>
        <a
          className='header__navigation_link'
          href='/'
          onClick={ev => ev.preventDefault()}
        >
          <small>{currentDomain.languageCode.toUpperCase()}</small>
          <small className='ml-2'>
            {currency || availableCurrencies[0].code}
          </small>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='h-3 w-3 ml-1 text-primary'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M19 9l-7 7-7-7'
            />
          </svg>
        </a>
        <div className='header__dropdown_menu-wrapper w-site-settings -mt-1 flex bg-white border border-solid border-grey-lighter py-4'>
          <div className='w-1/2 border-0 border-r border-solid border-grey-lighter header-px-5'>
            <div className='text-xl font-light mb-4'>Languages</div>
            <ul className='site-settings-list capitalize'>
              {urls.map(
                ({
                  siteId,
                  href,
                  languageCode,
                  languageName,
                  isCurrentSite,
                }) => (
                  <li key={siteId}>
                    <a
                      href={generateUrl(href, currency)}
                      hrefLang={languageCode}
                      className={`dropdown-link ${
                        isCurrentSite ? 'font-semibold' : 'font-normal'
                      }`}
                    >
                      <img
                        alt=''
                        width={27}
                        height={17}
                        className='mr-2'
                        src={`${process.env.PUBLIC_PATH}assets/images/flags/${languageCode}.jpg`}
                      />{' '}
                      {languageName}
                    </a>
                  </li>
                ),
              )}
            </ul>
          </div>
          <div className='w-1/2 header-px-5'>
            <div className='text-xl font-light mb-4'>Currency</div>
            <ul className='site-settings-list capitalize'>
              {availableCurrencies.map(({ code }) => (
                <li key={code}>
                  <button
                    type='button'
                    data-currency-code={code}
                    onClick={handleCurrencyChange(code)}
                    className={getButtonClassnames(
                      false,
                      'border-0 outline-none p-0',
                      'wl-spainholiday-header-currency-link dropdown-link',
                      (currency || availableCurrencies[0].code) === code
                        ? 'font-semibold'
                        : 'font-normal',
                    )}
                  >
                    {code}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  )
}
